import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { formDataAtom } from "../App";
import { FormModel } from "../types/FormTypes";
import * as Yup from "yup";
import { useEffect, useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { COMPENSATION_TAXI } from "./Compensation";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  MultipleFileUploadField,
  Heading,
} from "@ogt/ui";

export default function CompensationForTaxi() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 60;
  // Reset specific fields if the selected compensation is not COMPENSATION_TAXI
  useEffect(() => {
    if (formData.compensation === COMPENSATION_TAXI) {
      setFormData((prev) => ({
        ...prev,
        distance: "",
        cartravelfrom: "",
        cartravelto: "",
        carlicenceplate: "",
        carexpenses: [],
      }));
    }
  }, [formData.compensation, setFormData]);

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });
          navigate("/hur-vill-du-ha-ersattning");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          taxireceipt: Yup.array()
            .of(Yup.mixed().required("Kvitto är obligatoriskt"))
            .min(1, "Vänligen bifoga ett kvitto innan du går vidare."),
        })}
      >
        {({ errors, touched, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <>
                  <Heading progress={progress} headingRef={h2Ref} focusable>
                    Ersättning för resa med taxi
                  </Heading>

                  {Object.keys(errors).length > 0 && (
                    <ErrorList errors={errors} />
                  )}

                  <p>
                    Ladda upp kvitto från resan med taxi (bild på kvittot
                    räcker). Du kan få ersättning upp till 1/40-del av gällande
                    prisbasbelopp.
                  </p>

                  <MultipleFileUploadField
                    currentFiles={values.taxireceipt}
                    multiple={true}
                    type="Kvitton"
                    label="Bifoga kvitto från taxiresa"
                    inputId="taxireceipt"
                    inputName="taxireceipt"
                  />
                </>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
